// extracted by mini-css-extract-plugin
module.exports = {"header":"CheckoutHeader_header__1_gDW","logoContainer":"CheckoutHeader_logoContainer__1HHfQ"};